// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import api from './assets/api.js'
import inaxios  from '@/assets/axiosConfig.js'
// import 'ant-design-vue/dist/antd.css';
import './assets/newantdesign.less'
import './assets/newall.css'
import vuefun from './assets/app.js'
import clang from './assets/language.js'
import timgname from './components/titleimg/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import WebpPlugun from 'vue-webp-plugin';
import locale from 'element-ui/lib/locale/lang/en'; // 导入英文语言包
inaxios()
// Vue.use(WebpPlugun);
Vue.use(timgname)
Vue.use(ElementUI, { locale });
Vue.prototype.$api = api;
Vue.prototype.$ajax = axios;
Vue.prototype.$lang = clang;
Vue.config.productionTip = false;
axios.defaults.withCredentials = true;

Vue.use(Antd);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  axios,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js